<template>

    <section class="c-events">
        <h3>Lista planowanych wizyt</h3>
        <v-table v-if="events.length">
            <thead>
            <th>Data</th>
            <th>Godzina</th>
            <th>Typ wizyty</th>
            <th>Lokalizacja</th>
            <th>Dostępne akcje</th>
            </thead>
            <tbody ref="tbody">
            <tr
                v-for="(event, index) in compEvents"
                :key="index">
                <td>{{ event.date }}</td>
                <td>{{ event.hours }}</td>
                <td>{{ event.type }}</td>
                <td>{{ event.location }}</td>
                <td class="c-events__actions">
                    <v-btn
                        type="green"
                        size="small"
                        @click="$refs.visitAddModal.$emit('open', event, patient.id)">
                        Rozpocznij
                    </v-btn>
                    <v-btn
                        type="icon"
                        icon="edit"
                        title="Edytuj zaplanowaną wizytę"
                        :to="{ name: 'PatientEventEdit', params: { id: patient.id, eventId: event.id } }">
                    </v-btn>
                    <v-btn
                        type="icon"
                        icon="delete"
                        title="Usuń zaplanowaną wizytę"
                        @click="$refs.eventRemoveModal.$emit('open', event.id)">
                    </v-btn>
                </td>
            </tr>
            </tbody>
            <v-loader
                :loading="isFetching"
                :bind-to="$refs.tbody">
            </v-loader>
        </v-table>
        <p v-else class="c-events__empty">
            <span>Brak planowanych wizyt</span>
            <v-btn
                class="c-events__empty-btn"
                type="white"
                :to="{ name: 'PatientEventAdd', params: $route.params }">
                Zaplanuj wizytę
            </v-btn>
        </p>
        <v-pagination v-model="events.last_page" name="events_page"></v-pagination>
        <visit-add-modal ref="visitAddModal"></visit-add-modal>
        <event-remove-modal @success="removeEvent" ref="eventRemoveModal"></event-remove-modal>
    </section>

</template>


<script>

import {mapGetters} from 'vuex'
import moment from 'moment'
import VBtn from 'Components/VBtn'
import VTable from 'Components/VTable'
import VisitAddModal from 'Components/Visit/VisitAddModal'
import EventRemoveModal from 'Components/Event/EventRemoveModal'
import VPagination from 'Components/VPagination'
import VLoader from 'Components/VLoader'

export default {

    name: 'PatientEvents',

    data() {
        return {
            isFetching: false
        }
    },

    computed: {
        ...mapGetters('patient', ['patient', 'events']),
        compEvents() {
            var _events = []

            return this.events.map((event) => {
                return {
                    id: event.id,
                    date: moment(event.start).format('YYYY-MM-DD'),
                    hours: moment(event.start).format('HH:mm') + ' - ' + moment(event.end).format('HH:mm'),
                    type: (event.type === 'office') ? 'W gabinecie' : 'Domowa',
                    location: ((event.office_id) ? event.office.name : event.mobile_city) || '-'
                }
            })
        },
        currentPage() {
            return this.$route.query.events_page
        }
    },

    methods: {
        removeEvent(eventId) {
            this.events = this.events.filter((event) => {
                return event.id !== eventId
            })
            var eventsPage = this.$route.query.events_page
            if (this.events.length === 0 && eventsPage > 1) {
                this.$router.push({query: {events_page: eventsPage - 1}})
            }
        }
    },

    watch: {
        '$route.query.events_page'() {
            this.isFetching = true
            this.$store.dispatch('patient/FETCH_EVENTS', {
                id: this.patient.id,
                page: this.currentPage,
            }).then(() => {
                this.isFetching = false
            }).catch(() => {
                this.isFetching = false
            })
        }
    },

    components: {
        VBtn,
        VisitAddModal,
        EventRemoveModal,
        VPagination,
        VTable,
        VLoader
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-events {
    &__empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 1.2rem;
        margin: 2rem 0;
        width: 100%;
        text-align: center;

        &-btn {
            margin-top: 1rem;
        }
    }
    &__actions {
        display: flex;
        width: 100%;
        justify-content: flex-end;
        flex-shrink: 0;

        span {
            margin-right: .5rem;

            &:last-child {
                margin-right: 0;
            }
        }
    }
}

</style>
